// Copyright (C) 2020 Really Awesome Technology Ltd
//
// This file is part of RACTF.
//
// RACTF is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published
// by the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// RACTF is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with RACTF.  If not, see <https://www.gnu.org/licenses/>.

import React from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@ractf/ui-kit";

import broken from "static/broken.png";
import Link from "components/Link";

import "./ErrorPages.scss";


export const BrokenShards = () => <img alt={""} className={"errorImg"} src={broken} />;

export const ErrorPage = ({ code, details }) => {
    const { t } = useTranslation();

    return <Page className={"errorWrap"} centre>
        <div>{code || t("errors.generic")}</div>
        <div>{details}</div>
        <Link to={"/"}>{t("errors.return")}</Link>
    </Page>;
};

export const NotFound = () => {
    const { t } = useTranslation();

    return <ErrorPage code={404} details={t("errors.404")} />;
};
